module.exports = __webpack_public_path__ + "img/pro_emm_04.c9067136.png";